import type {Content} from '@prismicio/client'
import type {SliceComponentProps} from '@prismicio/react'
import type {FC} from 'react'
import type {Context} from 'src/common/types'
import {ProductOverviewDefaultVariation} from './DefaultVariation'
import {ProductOverviewHighlightsVariation} from './HighlightsVariation'
import {ProductOverviewIconsVariation} from './IconsVariation'
import {ProductOverviewProductBenefitsVariation} from './ProductBenefitsVariation'

/**
 * Props for `ProductOverview`.
 */
export type ProductOverviewProps = SliceComponentProps<Content.ProductOverviewSlice> & {context: Context}

/**
 * Component for "ProductOverview" Slices.
 */
const ProductOverview: FC<ProductOverviewProps> = ({slice, context, index: componentIndex}) => {
  switch (slice.variation) {
    case 'highlights':
      return <ProductOverviewHighlightsVariation slice={slice} />
    case 'gridWithIcons':
      return <ProductOverviewIconsVariation slice={slice} />
    case 'productBenefits':
      return <ProductOverviewProductBenefitsVariation slice={slice} />
    case 'default':
      return <ProductOverviewDefaultVariation slice={slice} context={context} componentIndex={componentIndex} />
    default:
      return null
  }
}

export default ProductOverview
